import * as React from "react";

export function DD() {
  return (
    <svg
      className="elm-pointer-events-none elm-block"
      width="27"
      height="37"
      viewBox="0 0 27 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.98779 0.19519H0.0722656V4.69613H8.98779C16.3728 4.69613 22.3574 10.7386 22.3574 18.1952C22.3574 25.6517 16.3691 31.6943 8.98779 31.6943H0.0722656V36.1952H8.98779C18.832 36.1952 26.8151 28.1348 26.8151 18.1952C26.8151 8.25562 18.832 0.19519 8.98779 0.19519Z"
        fill="#0E3478"
      />
      <path
        d="M17.8996 18.1952C17.8996 13.2254 13.9099 9.19331 8.98407 9.19331H0.0722656V27.1933H8.98779C13.9099 27.1971 17.8996 23.165 17.8996 18.1952ZM4.53003 13.6943H8.98779C11.4507 13.6943 13.4456 15.7084 13.4456 18.1952C13.4456 20.682 11.4507 22.6961 8.98779 22.6961H4.53003V13.6943Z"
        fill="#0E3478"
      />
    </svg>
  );
}
